import React, { useEffect } from 'react';
import { getViewportWidth } from 'reactjs/components/utility';

const useScrollResizeHook = (
  target: React.RefObject<HTMLElement>,
  className: string,
  hideInBottom: boolean = false
) => {
  useEffect(() => {
    const node = target.current;
    if (node) {
      const OFFSET = 80; // Offset between node and top of viewport
      const callback = () => {
        const anchor = (node.parentNode as HTMLElement).getBoundingClientRect()
          .top;
        if (anchor - OFFSET < 0) {
          node.classList.add(className);
        } else {
          node.classList.remove(className);
        }

        if (document?.body?.scrollHeight) {
          if (
            document.body.scrollHeight - window.scrollY < 1000 &&
            hideInBottom
          ) {
            node.classList.remove(className);
          }
        }
      };

      window.addEventListener('scroll', callback);
      return () => {
        window.removeEventListener('scroll', callback);
      };
    }

    return () => {};
  }, [target, className, hideInBottom]);

  useEffect(() => {
    window.onload = () => {
      const node = target.current;
      // we use sidebar to calculate the width that we need to apply
      const sidebar = document.getElementById('sidebar');
      if (node && sidebar) {
        const resize = () => {
          const isMobileView = getViewportWidth() < 992;
          const OFFSET = 32; // Padding of grid system's column
          const width = sidebar.clientWidth - OFFSET;
          node.style.width = isMobileView ? '100%' : `${width}px`;
        };

        resize();
        window.addEventListener('resize', resize);
        return () => {
          window.removeEventListener('resize', resize);
        };
      }

      return () => {};
    };
  }, [target]);
};

export default useScrollResizeHook;
